import { DateHelper } from "utils/helpers";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
class ActiveCategoryHelper {
  isCategoryActive = (category?: ApiModel.ProjectCategory): boolean => {
    const today = new Date();

    if (category?.endDate === undefined) return true;

    return (
      DateHelper.isBefore(today, new Date(category.endDate)) || DateHelper.isEqual(today, new Date(category.endDate))
    );
  };
}

const ActiveCategoryHelperInstance = new ActiveCategoryHelper();
export default ActiveCategoryHelperInstance;
